<kendo-textbox [class.ng-invalid]="asFormControl?.invalid" #textbox [clearButton]="true" type="password" [disabled]="disabled" [(ngModel)]="value" (ngModelChange)="valueChanged($event)" (blur)="onTouch()">
  <ng-template kendoTextBoxSuffixTemplate>
    <qpoint-icon [icon]="'eye'" [iconType]="'regular'" (click)="toggleVisibility()" *ngIf="value"></qpoint-icon>
  </ng-template>
</kendo-textbox>